import * as actionTypes from "./actionTypes";
import * as types from "./types";

//DB Extractor
const initWorkFlowState: types.IWorkflowState = {
    pending: false,
    workflow: null,
    error: null,
  };
  
  export const WorkFlowsReducer = (state = initWorkFlowState, action: types.PostWorkflowActions) => {
    switch (action.type) {
      case actionTypes.POST_WORKFLOW_REQUEST:
        return {
          ...state,
          pending: true,
        };
      case actionTypes.POST_WORKFLOW_SUCCESS:
        return {
          ...state,
          pending: false,
          workflow: action.payload.workflow,
          error: null,
        };
      case actionTypes.POST_WORKFLOW_FAILURE:
        return {
          ...state,
          pending: false,
          workflow: null,
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };